import { CKButton } from 'clearkit';

import ChipInput from '~/components/ChipInput';

import styles from './styles';

const validateReferrer = (referrer) => {
  if (referrer === '') return;

  const referrerUrl = referrer.includes('//') ? referrer : `http://${referrer}`;

  const validReferrer = new URL(referrerUrl).hostname.replace('%2A.', '');
  if (!validReferrer || !validReferrer.includes('.')) {
    return;
  }

  return validReferrer;
};

const JavaScriptReferrers = ({
  classes,
  className,
  loading,
  referrers: referrersProp,
  onSave: onSaveProp,
  showHeading,
}) => {
  const [formDirty, setFormDirty] = useState(false);
  const [referrers, setReferrers] = useState([]);

  useEffect(() => {
    if (referrersProp && referrersProp.length) {
      setReferrers(referrersProp);
    }
  }, [referrersProp]);

  const addReferrer = (referrer) => {
    const validReferrer = validateReferrer(referrer);

    if (!validReferrer) return;

    setFormDirty(true);

    setReferrers([...referrers, validReferrer]);
  };

  const removeReferrer = (referrer) => {
    setFormDirty(true);

    setReferrers(
      referrers.filter((currentReferrer) => currentReferrer != referrer),
    );
  };

  const onSave = async () => {
    await onSaveProp(referrers);

    setFormDirty(false);
  };

  return (
    <div className={className}>
      {showHeading && (
        <>
          <h2 className="text-base font-medium text-gray-600">
            Allowed Referrers
          </h2>
          <p className="mt-2 mb-4 text-sm text-gray-600">
            Add the domains you want to allow the snippet to load on below. The{' '}
            <a
              className={classes.integrationLink}
              target="_blank"
              rel="noopener noreferrer"
              href="https://help.clearbit.com/hc/en-us/articles/360010019734-Getting-started-with-clearbit-js">
              installation guide
            </a>{' '}
            has complete instructions.
          </p>
        </>
      )}
      <div className="flex flex-row items-stretch">
        <ChipInput
          fullWidth
          inputRootClass={classes.chipInputRoot}
          rootClassName={classes.chipRoot}
          onDelete={removeReferrer}
          onBlur={(event) => addReferrer(event.target.value)}
          onAdd={addReferrer}
          value={referrers}
        />
        <CKButton
          isDisabled={!formDirty || loading}
          variant="bold"
          variantColor="blue"
          className={classes.referrersButton}
          onClick={onSave}>
          {loading ? 'Saving...' : 'Save'}
        </CKButton>
      </div>
    </div>
  );
};

JavaScriptReferrers.propTypes = {
  onSave: PropTypes.func,
  loading: PropTypes.bool,
  referrers: PropTypes.arrayOf(PropTypes.string),
  showHeading: PropTypes.bool,
};

JavaScriptReferrers.defaultProps = {
  onSave: () => {},
  loading: false,
  referrers: [],
  showHeading: true,
};

export default withStyles(styles)(JavaScriptReferrers);
